import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import Application from '@/common/application';

import { store } from '@/common/root';
import initPlugins from '@/common/plugins';
import { createPinia, mapState, PiniaVuePlugin } from 'pinia';
import wsPlugin from '@/common/store/plugins/wsPlugin';
import useAuthStore from '@/common/store/pinia/auth';
import { initApi } from '@/common/utils/api';
import initSubscriptions from '@/common/utils/subscriptions';
import useTelemetryStore from '@/common/store/pinia/telemetry';
import App from './App.vue';
import getRouter from './routes/index';
import init from './init';

Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(wsPlugin);
const router = getRouter(pinia);

sync(store, router, { moduleName: 'routes' });

useTelemetryStore(pinia).initialize();

initApi({ authStore: useAuthStore(pinia) });
initPlugins(pinia);
init(pinia);
initSubscriptions();

export default new Vue({
  components: { App },
  extends: Application,
  router,
  pinia,
  computed: {
    ...mapState(useAuthStore, ['currentUser'])
  },
  watch: {
    currentUser(value) {
      if (!value) {
        this.$router.push({
          path: '/login',
          query: {
            redirectUrl: this.$route.fullPath
          }
        });
      }
    }
  },
  render: h => h(App)
});
